import React from 'react';
import classes from "./SuccessPage.module.css";
import { AiOutlineCheckCircle } from 'react-icons/ai';

const DeactivateSuccess = () => {
  return (
    <div className={classes.wrapper}>
            <div className={classes.statusContainer}>
                <AiOutlineCheckCircle className={classes.iconSuccess} />
                <h2>Success</h2>
                <p>You have been successfully deactivated from the service.</p>
                <button type="button" className={classes.button}
                onClick={()=>{
                    window.location.href="https://subscribe-d2g.rashigames.com/"
                }}
                >
                    Go Back
                </button>
            </div>
        </div>
  )
}

export default DeactivateSuccess